// @ts-strict-ignore
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { CustomValidators } from '@shared/custom-validators';
import { AlertHelper } from '@shared/alert/alert.helper';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleEndPlateInfoVO } from '@article/model/vo/article-end-plate-info-vo';
import { ArticleDataService } from '@article/service/article-data.service';

@Component({
  standalone: false,
  selector: 'app-add-endplate',
  templateUrl: './add-endplate.component.html',
  styleUrls: ['./add-endplate.component.scss'],
})
export class AddEndplateComponent implements OnInit {
  @Output() public finish = new EventEmitter<ArticleEndPlateInfoVO>();

  private readonly NUMBER_RESTRICTER: string = '^[0-9]*$';

  public form: FormGroup;
  public inputValueRestricter = this.NUMBER_RESTRICTER;
  public rotated;

  constructor(
    private bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private alertHelper: AlertHelper,
    private articleDataService: ArticleDataService,
    private localeResourceManager: LocaleResourceManager
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      otherArticleNo: new FormControl('', CustomValidators.required),
      rotated: new FormControl(''),
    });
    this.rotated = false;
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    const secondArticleSource: string = this.form.controls.otherArticleNo.value;
    this.articleDataService.loadArticleByIdOrArticleNumberAndVersion(secondArticleSource).subscribe((secondArticle: ArticleVO) => {
      if (!secondArticle) {
        this.alertHelper.showError('searchArticleView.title.no_articles_found', 'searchArticleView.message.no_articles_found', {
          translationParams: [secondArticleSource],
        });
        this.form.controls.otherArticleNo.setErrors({});
      } else {
        const endPlate: ArticleEndPlateInfoVO = {
          id: null,
          articleNo: null,
          otherArticleNo: secondArticleSource,
          deleted: 0,
          rotated: this.rotated,
        };
        this.finish.emit(endPlate);
        this.close();
      }
    });
  }

  public getInputError(c: AbstractControl): string {
    if (c && c.hasError('messageKey')) {
      return this.localeResourceManager.getValueByKey(c.getError('messageKey'), { 0: c.getError('param') });
    } else {
      return '';
    }
  }
}
